import { useClient } from 'modules/settings/providers/ClientProvider';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { FC, Fragment, useState } from 'react';
import { MenuClose, MenuIcon } from 'ui/Icons';
import NavSideBar from 'ui/NavSideBar';
import { VariantTypes } from 'ui/uiTypes';

import navbarDataLinks from './navbarDataLinks';
import {
  CloseIconContainer,
  Links,
  MenuControl,
  Option,
  SideNavBarHomePage,
  SideNavHomePageContent,
} from './styles';

interface Props {
  desktop?: boolean;
  variant?: VariantTypes;
}

const APP_ROUTE_SEPERATION = 4;

const NavbarLinks: FC<Props> = ({ desktop, variant }) => {
  const [toogleSidebar, settoogleSidebar] = useState(false);
  const router = useRouter();
  const getVariant = (path: string) =>
    router.pathname === path ? VariantTypes.IS_ACTIVE : variant;
  const { client } = useClient();
  return (
    <>
      <Links desktop={desktop} variant={variant} data-testid="navbarLinks">
        {navbarDataLinks(client).map((val, i) => {
          const LastLink =
            i === navbarDataLinks(client).length - APP_ROUTE_SEPERATION;
          return (
            <Fragment key={`des-${i}-${val.link}`}>
              <div>
                <Link
                  href={`/${val.link}`}
                  data-cy={val.link}
                  data-testid={val.label}
                >
                  <Option variant={getVariant(`/${val.link}`)}>
                    {val.label}
                  </Option>
                </Link>
              </div>
              {LastLink && <span id="seperator">|</span>}
            </Fragment>
          );
        })}
      </Links>
      <MenuControl>
        <MenuIcon onClick={() => settoogleSidebar(!toogleSidebar)} />
      </MenuControl>
      <NavSideBar
        active={toogleSidebar}
        side="right"
        onClickClose={() => settoogleSidebar(!toogleSidebar)}
        as={SideNavBarHomePage}
      >
        <CloseIconContainer>
          <MenuClose onClick={() => settoogleSidebar(!toogleSidebar)} />
        </CloseIconContainer>
        <SideNavHomePageContent>
          {navbarDataLinks(client).map((val, i) => (
            <Link
              href={`/${val.link}`}
              key={`${i}-${val.link}`}
              data-cy={val.link}
            >
              <Option variant={getVariant(`/${val.link}`)}>{val.label}</Option>
            </Link>
          ))}
        </SideNavHomePageContent>
      </NavSideBar>
    </>
  );
};

export default NavbarLinks;
